var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-navigation-item"},[_c('button',{class:{valid: _vm.valid === true, invalid: _vm.valid === false, active: _vm.active === true, focused: _vm.focused},attrs:{"type":"button"},on:{"click":function($event){return _vm.changeSection(_vm.id)},"keyup":_vm.focusElement,"blur":_vm.unfocusElement}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }